import { z } from 'zod';
import { InvoiceIdSchema, IsoUtcTimestampSchema, TenantIdSchema } from './primitives';

export const MlsCodeSchema = z.enum(['RE', 'AB', 'AP']);
export type MlsCode = z.infer<typeof MlsCodeSchema>;

export const MlsEventSchema = z.object({
  mlsEventId: z.string().uuid(),
  invoiceId: InvoiceIdSchema,
  tenantId: TenantIdSchema,
  mlsCode: MlsCodeSchema,
  webhookSignature: z.string().min(1).max(128),
  webhookPayloadHash: z.string().regex(/^[0-9a-f]{64}$/u),
  errorDetail: z
    .object({
      code: z.string(),
      field: z.string().optional(),
      message: z.string(),
    })
    .nullable()
    .default(null),
  receivedAt: IsoUtcTimestampSchema,
});
export type MlsEvent = z.infer<typeof MlsEventSchema>;
